import { render, staticRenderFns } from "./carousel-slide.vue?vue&type=template&id=65c6517e&"
import script from "./carousel-slide.vue?vue&type=script&lang=js&"
export * from "./carousel-slide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65c6517e')) {
      api.createRecord('65c6517e', component.options)
    } else {
      api.reload('65c6517e', component.options)
    }
    module.hot.accept("./carousel-slide.vue?vue&type=template&id=65c6517e&", function () {
      api.rerender('65c6517e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/carousel/carousel-slide.vue"
export default component.exports